import React from 'react';
import { clsx } from 'clsx';

import { AntBreakpoints } from 'works/legacy/lib/style-helper';

export const AppContent = ({
  className = '',
  left = true,
  top = true,
  right = true,
  bottom = true,
  children,
}: React.PropsWithChildren<{
  className?: string;
  left?: boolean;
  top?: boolean;
  bottom?: boolean;
  right?: boolean;
}>) => {
  const classes: string[] = [];

  if (top) {
    classes.push('pad-top');
  }
  if (left) {
    classes.push('pad-left');
  }
  if (right) {
    classes.push('pad-right');
  }
  if (bottom) {
    classes.push('pad-bottom');
  }

  return (
    <>
      <section className={clsx('AppContent', ...classes, className)}>
        {children}
      </section>
      <style jsx>{`
        .AppContent {
          background-color: white;
          flex-grow: 1;
        }
        .AppContent.pad-top {
          padding-top: 24px;
        }
        .AppContent.pad-left {
          padding-left: 24px;
        }
        .AppContent.pad-right {
          padding-right: 24px;
        }
        .AppContent.pad-bottom {
          padding-bottom: 24px;
        }

        @media (max-width: ${AntBreakpoints.xsPx}) {
          .AppContent.pad-top {
            padding-top: 16px;
          }
          .AppContent.pad-left {
            padding-left: 16px;
          }
          .AppContent.pad-right {
            padding-right: 16px;
          }
          .AppContent.pad-bottom {
            padding-bottom: 16px;
          }
        }
      `}</style>
    </>
  );
};
